import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowTopRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-arrow-top-right, open, new, link, open link, box, arrow"><path d="M9.25 5.75H3.75V20.25H18.25V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 3.75H20.25V10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.5 4.5L11 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareArrowTopRight;
